/**
 * Product Block Click Handler
 * Ensures product blocks are clickable by handling clicks on the container
 * and redirecting to the product link inside
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Function to handle product block clicks
  function handleProductBlockClick(event) {
    const blockInnerInner = event.currentTarget;
    const productLink = blockInnerInner.querySelector('a.product-link');
    
    console.log('Block inner clicked:', blockInnerInner);
    
    if (productLink && productLink.href) {
      console.log('Found product link:', productLink.href);
      
      // Check if the click was on a button (avoid interfering with buttons)
      const clickedElement = event.target;
      const isButton = clickedElement.tagName === 'BUTTON' ||
                       clickedElement.closest('button') ||
                       clickedElement.classList.contains('btn');
      
      if (!isButton) {
        console.log('Redirecting to:', productLink.href);
        event.preventDefault(); // Prevent any default link behavior
        window.location.href = productLink.href;
      } else {
        console.log('Click on button, not redirecting');
      }
    } else {
      console.log('No product link found in block');
    }
  }
  
  // Function to handle "View all search results" button clicks
  function handleViewAllClick(event) {
    const viewAllButton = event.currentTarget;
    
    console.log('View all button clicked:', viewAllButton);
    
    if (viewAllButton.href) {
      console.log('Found view all link:', viewAllButton.href);
      console.log('Redirecting to view all results:', viewAllButton.href);
      event.preventDefault(); // Prevent any default behavior
      window.location.href = viewAllButton.href;
    } else {
      console.log('No href found on view all button');
    }
  }
  
  // Add click handlers to existing product blocks and view all button
  function addClickHandlers() {
    const searchContainer = document.querySelector('.main-search__results_conteiner');
    if (!searchContainer) {
      console.log('Search results container not found');
      return;
    }
    
    // Handle product blocks
    const blockInnerInners = searchContainer.querySelectorAll('.block-inner-inner');
    console.log('Found', blockInnerInners.length, 'product blocks in search results');
    
    blockInnerInners.forEach(function(block) {
      // Remove existing handler to avoid duplicates
      block.removeEventListener('click', handleProductBlockClick);
      // Add click handler
      block.addEventListener('click', handleProductBlockClick);
      
      // Add visual feedback
      block.style.cursor = 'pointer';
    });
    
    // Handle "View all search results" button
    const viewAllButton = searchContainer.querySelector('a.main-search__results-all-link.btn.btn--secondary');
    if (viewAllButton) {
      console.log('Found view all search results button');
      // Remove existing handler to avoid duplicates
      viewAllButton.removeEventListener('click', handleViewAllClick);
      // Add click handler
      viewAllButton.addEventListener('click', handleViewAllClick);
      
      // Add visual feedback
      viewAllButton.style.cursor = 'pointer';
    } else {
      console.log('View all search results button not found');
    }
  }
  
  // Initialize on page load
  addClickHandlers();
  
  // Re-initialize when new content is loaded (for search results)
  const observer = new MutationObserver(function(mutations) {
    let shouldReinitialize = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if the node is inside search results container
            const searchContainer = document.querySelector('.main-search__results_conteiner');
            if (searchContainer && (searchContainer.contains(node) || node.contains && node.contains(searchContainer))) {
              if (node.classList && node.classList.contains('block-inner-inner') ||
                  node.querySelector && node.querySelector('.block-inner-inner') ||
                  node.classList && node.classList.contains('main-search__results-all-link') ||
                  node.querySelector && node.querySelector('a.main-search__results-all-link.btn.btn--secondary')) {
                shouldReinitialize = true;
              }
            }
          }
        });
      }
    });
    
    if (shouldReinitialize) {
      console.log('New product blocks detected in search results, reinitializing click handlers');
      setTimeout(addClickHandlers, 100); // Small delay to ensure DOM is ready
    }
  });
  
  // Observe the search results container specifically
  const searchResults = document.querySelector('.main-search__results_conteiner');
  if (searchResults) {
    observer.observe(searchResults, {
      childList: true,
      subtree: true
    });
    console.log('Observing search results container for changes');
  } else {
    console.log('Search results container not found for observation');
  }
  
  console.log('Product block click handler initialized');
});
